import { render, staticRenderFns } from "./AllProjects.vue?vue&type=template&id=cfb45f96&"
import script from "./AllProjects.vue?vue&type=script&lang=js&"
export * from "./AllProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports